<template>
  <section
    class="home-hero"
    aria-label="首页焦点轮播"
    @mouseenter="pauseAutoplay"
    @mouseleave="resumeAutoplay"
  >
    <div ref="heroSwiper" class="swiper home-hero__carousel">
      <div class="swiper-wrapper">
        <div v-for="(slide, index) in slides" :key="index" class="swiper-slide">
          <img
            class="home-hero__img"
            :src="require(`@/assets/images/${slide.src}`)"
            :alt="slide.alt"
            :loading="index === 0 ? 'eager' : 'lazy'"
            decoding="async"
          />
        </div>
      </div>
    </div>
    <div class="carousel-caption">
      <div
        v-for="(slide, index) in slides"
        :key="index"
        class="carousel-caption-item"
        :class="{ active: index === activeIndex }"
        @click="handleClick(index)"
      >
        <p class="carousel-caption-item-title">{{ slide.title }}</p>
        <!-- <p class="carousel-caption-item-sub">{{ slide.sub }}</p> -->
      </div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper";
import { Autoplay, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

export default {
  name: "HomeHero",
  data() {
    return {
      swiperInstance: null,
      activeIndex: 0,
      slides: [
        {
          title: "中组部信息技术支撑单位",
          sub: "服务全国700余万公务员",
          src: "banner-1.png",
          alt: "智慧科技，引领未来",
        },
        {
          title: "服务全国28个省市自治区",
          sub: "承建超75%的大型组工信息化项目",
          src: "banner-2.png",
          alt: "企业形象展示",
        },
        {
          title: "多领域业务垂直致深",
          sub: "多源数据一体融通，组工业务一件联办",
          src: "banner-3.png",
          alt: "企业形象展示",
        },
        {
          title: "AI+ 精研识人治事",
          sub: "智能标签精准识人，数智应用提质增效",
          src: "banner-4.png",
          alt: "企业形象展示",
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initSwiper();
    });
  },
  beforeDestroy() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }
  },
  methods: {
    initSwiper() {
      const el = this.$refs.heroSwiper;
      if (!el) return;

      this.swiperInstance = new Swiper(el, {
        modules: [Autoplay, EffectFade],
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        loop: true,
        speed: 800,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        on: {
          slideChange: (swiper) => {
            this.activeIndex = swiper.realIndex;
          },
        },
      });
    },
    handleClick(index) {
      if (this.swiperInstance) {
        this.swiperInstance.slideToLoop(index);
      }
    },
    pauseAutoplay() {
      this.swiperInstance?.autoplay?.stop();
    },
    resumeAutoplay() {
      this.swiperInstance?.autoplay?.start();
    },
  },
};
</script>

<style lang="less">
.home-hero {
  position: relative;
  width: 100%;
  height: calc(100vh - 170px);
  min-height: 360px;
  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 220px;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 100%
    );
    z-index: 10;
  }

  .home-hero__carousel {
    width: 100%;
    height: 100%;

    &.swiper {
      margin-left: auto;
      margin-right: auto;
    }

    .swiper-wrapper {
      height: 100%;
    }

    .swiper-slide {
      height: 100%;
    }
  }

  .home-hero__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
  }

  .carousel-caption {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    height: 94px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    z-index: 100;

    .carousel-caption-item {
      width: 400px;
      height: 100%;
      padding: 0 0 0 26px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;

      &.active {
        background-image: url("@/assets/images/banner-active.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center bottom 0;
        .carousel-caption-item-title {
          // font-weight: 700;
          color: rgba(244, 54, 8, 1);
        }
        // .carousel-caption-item-sub{
        // border-bottom: 1px solid rgba(244, 54, 8, 1);
        // }
      }

      .carousel-caption-item-title {
        font-size: 24px;
        color: rgba(56, 73, 89, 1);
        // margin-bottom: 10px;
      }

      .carousel-caption-item-sub {
        font-size: 20px;
        color: rgba(107, 109, 112, 1);
      }
    }
  }
}
</style>
